export enum PiralTestStrings {
	customModal = 'urn:sfmodal:entitlements:customModal',
	customBanner = 'urn:sfextslot:entitlements:customBanner',
}
